import { useCallback, useEffect } from 'react';

import { useCategorySpendLimitsStore } from '../stores/useCategorySpendLimits.store';
import { useSpendLimitsModalStore } from '../stores/useSpendLimitsModal.store';

export const useSpendLimitsModalActions = () => {
  const handleChangeVisibility = useSpendLimitsModalStore((state) => state.handleChangeVisibility);
  const modalVisible = useSpendLimitsModalStore((state) => state.modalVisible);
  const handleResetModal = useSpendLimitsModalStore((state) => state.handleReset);
  const handleSetIsSubmitted = useSpendLimitsModalStore((state) => state.handleSetIsSubmitted);

  const handleInitDraft = useCategorySpendLimitsStore((state) => state.handleInitDraft);
  const handleApplyDraft = useCategorySpendLimitsStore((state) => state.handleApplyDraft);
  const handleDiscardDraft = useCategorySpendLimitsStore((state) => state.handleDiscardDraft);
  const draftSpendLimits = useCategorySpendLimitsStore((state) => state.draftSpendLimits);

  useEffect(() => {
    if (modalVisible) {
      handleInitDraft();
    }
  }, [modalVisible, handleInitDraft]);

  const handleCancel = useCallback(() => {
    handleDiscardDraft();
    handleChangeVisibility(false);
    handleResetModal();
  }, [handleDiscardDraft, handleChangeVisibility, handleResetModal]);

  const handleApply = useCallback(() => {
    const hasErrors = draftSpendLimits.some(
      (item) => item.category_spend_limit !== '' && parseFloat(item.category_spend_limit) <= 0
    );

    handleSetIsSubmitted(true);

    if (hasErrors) {
      return;
    }

    handleApplyDraft();
    handleChangeVisibility(false);
    handleResetModal();
  }, [draftSpendLimits, handleSetIsSubmitted, handleApplyDraft, handleChangeVisibility, handleResetModal]);

  return {
    modalVisible,
    handleCancel,
    handleApply,
  };
};
